<template>
	<div class="min-h-screen bg-gray-100">
		<div class="flex justify-end py-6 px-6">
			<form-button
				:type="button"
				@click="logout"
				v-if="this.$store.getters.isLoggedIn"
				>Abmelden</form-button
			>
		</div>
		<div class="py-2 px-2">
			<router-view
				@update-loading-overlay="updateLoadingOverlay"
				@show-toast="toast"
			/>
		</div>
	</div>
	<transition ref="root" :name="transition">
		<spinning-loader :isLoading="isLoading" />
	</transition>
</template>

<script>
	import FormButton from "@/components/FormButton";
	import SpinningLoader from "@/components/SpinningLoader";
	import { useToast } from "vue-toastification";

	export default {
		components: {
			FormButton,
			SpinningLoader,
		},
		data() {
			return {
				isLoading: false,
			};
		},
		methods: {
			logout() {
				this.toast({
					message: "Abmeldung erfolgreich!",
					type: "success",
				});
				this.$store.dispatch("logout");
				this.$router.push("/login");
			},
			updateLoadingOverlay(loading) {
				this.isLoading = loading;
			},
			toast(e) {
				let toast = useToast();

				toast(e.message, {
					type: e.type,
					position: "top-center",
					closeOnClick: true,
					pauseOnFocusLoss: true,
					pauseOnHover: true,
					hideProgressBar: true,
					icon: false,
				});
			},
		},
	};
</script>

<style src="./assets/css/style.css"></style>
